// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3rQr0","productName":"Table_productName__1qZ3i"};